import { render } from "./sumologic.vue?vue&type=template&id=e372d712"
import script from "./sumologic.vue?vue&type=script&lang=js"
export * from "./sumologic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__